<template>
    <div id="header-fixed" class="tenant-notification-banner" v-if="message">
        <div class="container-header-fixed">
            <div class="message-header-fixed">
                <span v-html="message"></span>
            </div>
            <div v-if="!lock_close">
                <button class="close-header-fixed" style="outline: none; font-size: 13px" 
                    @click="closeAlert">x</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NotificationListener',
        props: {
            lock_close: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                message: null,
                notification_id: null
            }
        },
        watch: {
            message() {
                this.updateLayoutOffset()
            }
        },
        async mounted() {
            window.addEventListener('resize', this.updateLayoutOffset)
            window.Echo.channel(`tenant.${window.websiteUuid}.notifications`)
                .listen('.NotificationTenant', async (e) => {
                    this.message = e.message
                    const notification = Array.isArray(e.notifications) ?
                        e.notifications.find(notification => notification.uuid === window.websiteUuid)
                        : null
                    this.notification_id = notification ? notification.notification_id : null
                    await this.markAsRead()
                })

            window.Echo.channel(`tenant.${window.websiteUuid}.close-notification`)
                .listen('.CloseNotificationTenant', async (e) => {
                    this.message = null
                })

            await this.loadNotifications()
            
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.updateLayoutOffset)
            this.clearLayoutOffset()
        },
        methods: {
            updateLayoutOffset() {
                this.$nextTick(() => {
                    const root = document.documentElement

                    if (this.message && this.$el instanceof HTMLElement) {
                        const height = this.$el.getBoundingClientRect().height

                        root.style.setProperty(
                            '--tenant-notification-height',
                            `${height}px`
                        )

                        root.classList.add('has-tenant-notification')
                    } else {
                        this.clearLayoutOffset()
                    }
                })
            },

            clearLayoutOffset() {
                const root = document.documentElement

                root.classList.remove('has-tenant-notification')
                root.style.removeProperty('--tenant-notification-height')
            },
            async closeAlert() {
                if (this.lock_close) return
                
                this.message = null
                const { data } = await this.$http.post(`/close-notification`, {
                    notification_id: this.notification_id
                })
            },

            async markAsRead () {
                const { data } = await this.$http.post(`/mark-as-read`, {
                    notification_id: this.notification_id
                })
            },

            async loadNotifications() {
                try {
                    const { data } = await this.$http.get(`/load-notifications-by-user`)
                    if (data.success) {
                        if (data.notifications.length) {
                            this.notification_id = data.notifications[0].notification_id || null
                            this.message = data.notifications[0].notification.message || null
                            await this.markAsRead()
                        }
                    }
                } catch (error) {
                    
                }
            }
        },
    }
</script>

<style>

    .tenant-notification-banner {
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 1030;              /* sobre .header (1020) y .sidebar-left / .page-header (1010) */
        padding: 8px 0;
        background-color: #8c00ff;
        color: #fff;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);

    }
    .header-fixed {
        display: block;
        /*position: fixed;*/
        top: 0;
        left: 0;
        width: 100%;
        background-color: #8c00ff;
        color: #000;
        text-align: left;
        padding: 8px 0;
        z-index: 9999;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
        color: #fff;
    }

    .container-header-fixed {
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
    }

    .close-header-fixed {
        border: none;
        background-color: #8c00ff;
        border-radius: 3px;
        color: #fff;
        transition: all .3s ease;
        outline: none;
    }

    .close-header-fixed:hover {
        background-color: rgba(0, 0, 255, 0.459);
    }
    
    .message-header-fixed ul {
        margin: 8px 0 0 18px;
        padding: 0;
    }

    .message-header-fixed li {
        text-align: left;
    }
    .message-header-fixed,
    .message-header-fixed p,
    .message-header-fixed span,
    .message-header-fixed div,
    .message-header-fixed ul,
    .message-header-fixed li,
    .message-header-fixed strong,
    .message-header-fixed b,
    .message-header-fixed small,
    .message-header-fixed a {
        color: #fff !important;
    }
    :root {
            --tenant-notification-height: 0px;
        }

            html.has-tenant-notification body {
                padding-top: var(--tenant-notification-height);
            }

            html.has-tenant-notification .body {
                min-height: calc(100vh - var(--tenant-notification-height));
            }


        @media only screen and (min-width: 768px) {
            html.fixed.has-tenant-notification .header {
                top: var(--tenant-notification-height);
            }

            html.fixed.has-tenant-notification .sidebar-left {
                top: var(--tenant-notification-height);
                min-height: calc(100vh - var(--tenant-notification-height));
            }

            html.fixed.has-tenant-notification .page-header {
                top: calc(60px + var(--tenant-notification-height));
            }

            /*html.no-mobile-device.has-tenant-notification .inner-wrapper {
                height: calc(100vh - var(--tenant-notification-height));
                min-height: calc(100vh - var(--tenant-notification-height));
            }*/
            
        }

        @media only screen and (max-width: 767px) {
            html.has-tenant-notification .header  .logo-container {
                top: var(--tenant-notification-height);
            }
            html.has-tenant-notification .sidebar-left {
                top: var(--tenant-notification-height);
            }
        }
        
</style>


// WEBPACK FOOTER //
// resources/js/views/tenant/common/NotificationListener.vue